<div class="input-group phone-input-wrap">
  <span class="input-group-btn">
    <button class="btn" type="button">
      <span class="flag-icon {{ flag }}"></span>
    </button>
  </span>

  <input data-tests-id="phone_input" type="tel" class="form-control input_field" #phoneInput (keyup)="keyUp($event)" (input)="onChange($event)" [disabled]="disabled">
</div>
